import { render } from "./OplAuthorizationListView.vue?vue&type=template&id=a1f804fa"
import script from "./OplAuthorizationListView.vue?vue&type=script&lang=js"
export * from "./OplAuthorizationListView.vue?vue&type=script&lang=js"

import exportComponent from "/home/rampa/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__